"use strict";

exports.__esModule = true;
exports.ElementTreeLabel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDnd = require("react-dnd");
var _ElementEditorContext = require("../ElementEditorContext");
var _dec, _dec2, _dec3, _class, _ElementTreeLabel;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var elementSource = {
  beginDrag: function beginDrag(props) {
    var element = props.element,
      path = props.path,
      elementEditor = props.elementEditor;
    elementEditor.beginDrag(path);
    return {
      element: element,
      path: path
    };
  },
  endDrag: function endDrag(props) {
    var elementEditor = props.elementEditor;
    elementEditor.endDrag();
  }
};
var widgetTarget = {
  drop: function drop(props, monitor) {
    var elementEditor = props.elementEditor;
    var hasDroppedOnChild = monitor.didDrop();
    if (hasDroppedOnChild || !monitor.isOver({
      shallow: true
    })) {
      return;
    }
    var itemType = monitor.getItemType();
    if (itemType === "element") {
      var _monitor$getItem = monitor.getItem(),
        path = _monitor$getItem.path;
      elementEditor.moveElementAt(path, props.path, {});
    } else if (itemType === "widget") {
      // eslint-disable-next-line react/no-find-dom-node
      var _monitor$getItem2 = monitor.getItem(),
        widget = _monitor$getItem2.widget;
      var element = widget.createElement({});
      elementEditor.appendElementAt(props.path, element);
    }
  }
};

/**
 * Drag / droppable label for ElementTree
 */
var ElementTreeLabel = exports.ElementTreeLabel = (_dec = _ElementEditorContext.ElementEditorContext.withContext, _dec2 = (0, _reactDnd.DropTarget)(["widget", "element"], widgetTarget, function (connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}), _dec3 = (0, _reactDnd.DragSource)("element", elementSource, function (connect) {
  return {
    connectDragSource: connect.dragSource()
  };
}), _dec(_class = _dec2(_class = _dec3(_class = (_ElementTreeLabel = /*#__PURE__*/function (_Component) {
  function ElementTreeLabel() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementTreeLabel, _Component);
  var _proto = ElementTreeLabel.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      path = _this$props.path,
      element = _this$props.element,
      widget = _this$props.widget,
      connectDragSource = _this$props.connectDragSource,
      connectDropTarget = _this$props.connectDropTarget;

    // eslint-disable-next-line no-nested-ternary
    var label = widget ? widget.getElementLabel ? widget.getElementLabel(element) : widget.label : element.type;
    return connectDropTarget(connectDragSource(/*#__PURE__*/_react["default"].createElement("div", null, label)));
  };
  return ElementTreeLabel;
}(_react.Component), _ElementTreeLabel.defaultProps = {
  elementEditor: undefined,
  connectDragSource: undefined,
  connectDropTarget: undefined
}, _ElementTreeLabel)) || _class) || _class) || _class);